<icon-label (click)="goBack()"
            [textClass]="'p1'"
            class="cursor-pointer"
            icon="arrow-left">{{ 'Continue shopping' | translate }} </icon-label>